import React from "react";
import InputSearch from "./Component/Search/InputSearch";
import PickColumn from "./Component/PickColumn/PickColumn";
import Filter from "./Component/Filter/Filter";
import CreatedOn from "./Component/CreatedOn/CreatedOn";
import Action from "./Component/Action/Action";
import AddGroup from "./Component/AddGroup/AddGroup";
import { Addbuyer } from "./Component/Utils/Utils";
import {
  Container,
  Header,
  HeaderIconLeft,
  HeaderIconRight,
  HeaderTitle,
  TableBody,
  TableContainer,
  TableHeader,
  Title,
} from "./Component/TableComponent/Table";

export default function AddProductsOsp() {
  const RowHeader = [
    "ProductID",
    "Status",
    "Product Name",
    "Product Cateogories",
    "Product HSN Code",
    "Assigned to",
    "Tags",
    "Actions",
  ];
  // const { rows, isLoading, error } = Usefetch_Get(
  //   "http://localhost:4000/Table"
  // );
 const path = "/admin-dashboard/view-osp/";

  return (
    <div>
      <Container>
        <Title message={'sdssd'} showImport={false}> Add Osp</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={Addbuyer}
              // isLoading={isLoading}
              // error={error}
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}

// AddProductsOsp()
// const path = "/admin-dashboard/view-osp/";